import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  MenuItem,
  CircularProgress
} from '@mui/material';

const RegisterParent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const schoolId = location.state?.schoolId || auth.schoolId;

  const [formData, setFormData] = useState({
    parentName: '',
    contactNumber: '',
    email: '',
    idNumber: '',
    gender: 'M',
    relationship: 'Mom',
    learnerAdmissionNumber: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
    }
  }, [schoolId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const parentData = {
        ...formData,
        schoolId
      };

      const response = await axios.post('https://kidsm.vercel.app/api/schools/register-parent', parentData);
      if (response.status === 201) {
        alert('Parent registered successfully!');
        setFormData({
          parentName: '',
          contactNumber: '',
          email: '',
          idNumber: '',
          gender: 'M',
          relationship: 'Mom',
          learnerAdmissionNumber: ''
        });
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to register parent. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Register Parent
        </Typography>
        
        {error && (
          <Typography color="error" align="center" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Parent Name"
            name="parentName"
            value={formData.parentName}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Contact Number"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
          />

          <TextField
            fullWidth
            label="ID Number"
            name="idNumber"
            value={formData.idNumber}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            select
            fullWidth
            label="Gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            margin="normal"
            required
          >
            <MenuItem value="M">Male</MenuItem>
            <MenuItem value="F">Female</MenuItem>
          </TextField>

          <TextField
            select
            fullWidth
            label="Relationship"
            name="relationship"
            value={formData.relationship}
            onChange={handleChange}
            margin="normal"
            required
          >
            <MenuItem value="Mom">Mom</MenuItem>
            <MenuItem value="Dad">Dad</MenuItem>
            <MenuItem value="Guardian">Guardian</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Learner's Admission Number"
            name="learnerAdmissionNumber"
            value={formData.learnerAdmissionNumber}
            onChange={handleChange}
            margin="normal"
            required
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, height: '48px' }}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Register Parent'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterParent;